import { IUserPhoneSchema } from '../../repositories/monolith-python/entities/user/UserPhoneSchema';
import { IPhone } from '../../types/user';

export const preparePhones = (phones: IUserPhoneSchema[]): IPhone[] => {
  return phones
    .filter(phone => phone.phone)
    .map(phone => ({
      confirmed: phone.confirmed || false,
      phone: `+${phone.phone}`,
    }));
};
